import { lazy } from "react";

export const MedicalCardsHistoryAsync = lazy(
  () => import("./MedicalCardsHistory"),
);
